<template>
	<div class="divloginmain">
		<login v-if="type=='default'" ref="login_default"></login>
		<logindynamic v-if="type=='dynamic'" ref="login_dynamic" @Login="Login" @Register="Register" class="loginMain"></logindynamic>
	</div>
</template>

<script>
import logindynamic from '@/components/login/login_dynamic.vue';
import login from '@/components/login/login_default.vue';
export default {
	components: {
		logindynamic,
		login
	},
	data() {
		return {
			type:''
		}
	},
	mounted() {
		this.GetDomain();
	},
	methods:{
		GetDomain(){
			var that=this;
			if(localStorage.getItem('skip')!='1'){
				this.$apipost.get.GetDomainByIp().then(res => {
					if (res.state == '1') {
						//debugger
						localStorage.setItem('skip','1');
						window.location.href=window.location.href.replace(window.location.host,res.domain);
					}else{
						localStorage.removeItem('skip');
						that.sysinfo();
					}
				}).catch(e=>{
					that.GetDomain();
				});
			}
			else{
				localStorage.removeItem('skip');
				that.sysinfo();
			}
		},
		sysinfo() {
			var that = this;
			this.$apipost.get.sysinfo().then(res => {
				if (res.info != '') {
					//debugger
					localStorage.setItem('webtitle', res.info.c_webtitle);
					localStorage.setItem('c_folder', res.info.c_folder);
					localStorage.setItem('subwebtitle',res.info.c_subwebtitle);
					localStorage.setItem('logintype', res.info.logintype);
					that.type=res.info.logintype==''?'default':res.info.logintype;
					that.loadpage();
				}
			}).catch(e=>{
				that.sysinfo();
			});
		},
		loadpage(){
			var that=this;
			if(that.type=='default'){
				this.$nextTick(function(){
					this.$refs.login_default.init();
				});
			}
			else if(that.type=='dynamic'){
				this.$nextTick(function(){
					this.$refs.login_dynamic.init();
				});
			}
		},
		Login(form) {
			//debugger
			var that=this;
			//验证登录
			if (form.account == '') {
				this.$tool.message('请输入登录账号', 0);
				return false;
			}
			if (form.password == '') {
				this.$tool.message('请输入登录密码', 0);
				return false;
			}
			this.$tool.loading('正在登录', 'loginMain');
			this.$apipost.post.login({ account: form.account, password:this.$tool.setPwd(form.password) }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					//debugger
					if (res.state == '1') {
						if (res.token != '' && res.token != undefined) {
							localStorage.setItem('token', res.token);
							this.$router.push('/');
						}
					} else {
						this.$tool.message(res.message, 0);
					}
				}
			}).catch(e=>{
				this.$tool.loadingclose();
				this.$tool.message('网络异常，请重试', 0);
			});
		},
		Register(e,handletype) {
			//debugger
			var that=this;
			//验证登录
			if(handletype==undefined)
				handletype=1;
			if (e.form.account == '') {
				this.$tool.message('请输入注册账号', 0);
				return false;
			}
			if (e.form.password == '') {
				this.$tool.message('请输入密码', 0);
				return false;
			}
			if (e.form.shop == '') {
				this.$tool.message('请选择门店', 0);
				return false;
			}
			this.$tool.loading('正在注册', 'loginMain');
			var paraminfo={
				account: e.form.account,
				password:this.$tool.setPwd(e.form.password),
				shopname: e.form.shop,
				handletype:handletype,
				ewmid:e.ewmid
			}
			this.$apipost.post.registerAccount({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if (res.state == '1') {
						e.showscanewm=false;
						if (res.token != '' && res.token != undefined) {
							localStorage.setItem('token', res.token);
							this.$router.push('/');
						}
					} else {
						if(res.state=='2'){
							e.showscanewm=true;
							e.verifyewm=res.ewm;
							e.ewmid=res.ewmid;
						}
						else this.$tool.message(res.message, 0);
					}
				}
			}).catch(e=>{
				this.$tool.loadingclose();
				this.$tool.message('网络异常，请重试', 0);
			});
		}
	}
}
</script>

<style>
.divloginmain{
	overflow-y: auto;
}
</style>